import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import api from "../network/Api";
import { loadUserData } from "../slices/LoginSlice";

export const ApartmentSelectorScreen = () => {
    const [apartments, setApartments] = useState([]);
    const [selectedApartment, setSelectedApartment] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        api.get("/apartments/").then((response) => {
            let apartments = response.data;
            setSelectedApartment(apartments[0].id);
            setApartments(apartments);
        });
    }, []);

    const saveApartment = () => {
        api.put("/users/me/apartment", {
            apartment_id: selectedApartment,
        }).then((response) => {
            console.log("Save apartment response:", response);
            dispatch(loadUserData());
            navigate("/");
        });
    };

    const setSelectedApartmentHandler = (e) => {
        let apartment_id = e.target.value;
        console.log("Apartment id:", apartment_id);
        setSelectedApartment(apartment_id);
    };

    const openConfirm = () => setConfirmOpen(true);
    const closeConfirm = () => setConfirmOpen(false);
    const handleConfirm = () => {
        setConfirmOpen(false);
        saveApartment();
    };

    const selectedApartmentAddress = apartments.find(
        (a) => a.id === selectedApartment
    )?.address;

    return (
        <>
            <Grid container direction="column" rowSpacing="2em" alignItems="center">
                <Grid>
                    <Typography variant="h5">Válassza ki a címét:</Typography>
                </Grid>
                <Grid sx={{ width: { xs: "90vw", sm: "auto" } }}>
                    <Grid
                        container
                        direction={{ xs: "column", sm: "row" }}
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid sx={{ width: { xs: "100%", sm: "auto" } }}>
                            <Select
                                value={selectedApartment}
                                onChange={setSelectedApartmentHandler}
                                sx={{
                                    width: { xs: "100%", sm: 320 },
                                    color: "white",
                                    "& .MuiSelect-select.MuiSelect-select": {
                                        whiteSpace: "normal",
                                        overflow: "visible",
                                        textOverflow: "clip",
                                        wordBreak: "break-word",
                                        height: "auto",
                                    },
                                }}
                                MenuProps={{
                                    PaperProps: { sx: { maxWidth: "90vw" } },
                                }}
                            >
                                {apartments.map((apartment) => (
                                    <MenuItem
                                        key={apartment.id}
                                        value={apartment.id}
                                        sx={{ color: "black", whiteSpace: "normal" }}
                                    >
                                        {apartment.address}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid>
                            <Button variant="contained" onClick={openConfirm}>
                                Mentés
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog open={confirmOpen} onClose={closeConfirm}>
                <DialogTitle color="black">Megerősítés</DialogTitle>
                <DialogContent>
                    <DialogContentText color="black">
                        Biztosan ezt a címet választja: {selectedApartmentAddress}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirm}>Mégse</Button>
                    <Button onClick={handleConfirm} variant="contained" autoFocus>
                        Igen
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
